import styled from "@emotion/styled";
import { css } from "@emotion/react";
import colors from "../../styles/colors";
export const StatusPillContainer = styled.div `
  ${({ compact }) => compact
    ? `padding: 0.25rem 0.75rem;`
    : "padding: 0.25rem 0.75rem 0.25rem 0.5rem;"};
  width: fit-content;
  border-radius: 2rem;
  gap: 0.125rem;
  display: flex;
  color: ${colors["color-blue-180"]};
  align-items: center;
  justify-content: center;
  span {
    font-weight: 700;
  }
  letter-spacing: 0.03125rem;
  ${({ status }) => getBackgroundcolor(status)}
`;
export const StatusPillIcon = styled.div `
  display: flex;
`;
function getBackgroundcolor(status) {
    switch (status) {
        case "approved":
            return css `
        background-color: ${colors["color-green-30"]};
      `;
        case "review":
            return css `
        background-color: ${colors["color-purple-30"]};
      `;
        case "info":
            return css `
        background-color: ${colors["color-gold-60"]};
      `;
        case "warning":
            return css `
        background-color: ${colors["color-red-60"]};
      `;
        case "canceled":
            return css `
        background-color: ${colors["color-gray-30"]};
      `;
        case "checkout":
            return css `
        background-color: ${colors["color-blue-70"]};
      `;
        default:
            return css `
        background-color: ${colors["color-green-30"]};
      `;
    }
}
//# sourceMappingURL=StatusPill.styled.js.map